<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="adaptationModal businessApplicationEdit"
      :title="businessApplication.businessApplicationID ? '编辑' : '新建'"
      width="1200px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="businessApplication"
        :rules="ruleValidate"
        :disabled="disabled"
        class="form"
        label-width="100px">
      <div class="editTitle">商务申请信息</div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="商务编号">
            <el-input v-model="businessApplication.businessApplicationNO" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="businessApplication.customerName" readonly placeholder="请选择客户">
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectCustomerName.open()"/>
            </el-input>
            <customer-select ref="selectCustomerName" @select="selectCustomerName"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="业务员" prop="salesPersonName">
            <el-input v-model="businessApplication.salesPersonName" placeholder="请选择业务员" readonly>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="$refs.salesPersonSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="抄送商务" prop="sendPeopleName">
            <el-input v-model="businessApplication.sendPeopleName" placeholder="请选择商务" readonly>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="$refs.employeeSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户属性" prop="customerAttr">
            <el-select v-model="businessApplication.customerAttr">
              <el-option label="渠道" :value="1"/>
              <el-option label="直销" :value="0"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户类型" prop="customerType">
            <el-select v-model="businessApplication.customerType">
              <el-option label="已成交客户" :value="1"/>
              <el-option label="新客户" :value="0"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户联系人" prop="contact">
            <el-input v-model="businessApplication.contact" placeholder="请输入联系人姓名"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电话" prop="telephone">
            <el-input v-model="businessApplication.telephone" placeholder="请输入联系方式"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职位" prop="position">
            <el-select v-model="businessApplication.position" placeholder="请选择联系人职位" filterable>
              <el-option v-for="item in postList" :key="item.postID" :value="item.postName" :label="item.postName"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="签约返利">
            <el-select v-model="businessApplication.rebated">
              <el-option label="是" :value="0"/>
              <el-option label="否" :value="1"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="返利最小值">
            <el-input v-model="businessApplication.rebateRange0"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="返利最大值">
            <el-input v-model="businessApplication.rebateRange1"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="给予返利">
            <el-select v-model="businessApplication.rebateGive">
              <el-option label="是" :value="0"/>
              <el-option label="否" :value="1"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="小微">
            <el-select v-model="businessApplication.xiaoWei" prop="xiaoWei">
              <el-option label="直驱小微" :value="0"/>
              <el-option label="视显驱控一体小微" :value="1"/>
              <el-option label="关节模组小微" :value="2"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="有效期限">
            <el-select v-model="businessApplication.timeLimit">
              <!--              <el-option label="一次有效" :value="10"/>-->
              <el-option label="自定义期限" :value="20"/>
              <!--              <el-option label="永久有效" :value="30"/>-->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="businessApplication.timeLimit === 20" :span="16">
          <el-form-item label="选择期限" prop="beginEndDate">
            <el-date-picker
                v-model="businessApplication.beginEndDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                @change="beginEndDateChange"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col v-if="businessApplication.businessApplicationID" :span="8">
          <el-form-item label="状态" prop="statusName">
            <el-input v-model="businessApplication.statusName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="businessApplication.businessApplicationID" :span="8">
          <el-form-item label="制单人" prop="creatorName">
            <el-input v-model="businessApplication.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="businessApplication.businessApplicationID" :span="8">
          <el-form-item label="制单时间" prop="createdDate">
            <el-input v-model="businessApplication.createdDate" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px">
        <el-col :span="24">
          <el-form-item label="备注" prop="note">
            <el-input v-model="businessApplication.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">商务申请物料</div>
      <div>
        <el-button style="float: left" type="primary" @click="$refs.selectMaterial.open(materialFilter)">
          添加物料
        </el-button>
      </div>
      <el-table
          :data="businessApplication.priceVOS"
          border
          stripe
          row-key="pkid"
          :expand-row-keys="expandRowKeys">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div style="padding-left: 47px">
              <el-table border :data="scope.row.competitorList">
                <el-table-column type="index" align="center" label="#" width="45"/>
                <el-table-column prop="brand" label="品牌" width="200">
                  <template slot-scope="exScope">
                    <el-form-item :prop="`priceVOS.${scope.$index}.competitorList.${exScope.$index}.brand`" :rules="[{required: true, trigger: 'blur'}]" label-width="0" :show-message="false">
                      <el-input v-model="exScope.row.brand" placeholder="请输入"/>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="materialName" show-overflow-tooltip label="物料名称">
                  <template slot-scope="exScope">
                    <el-form-item :prop="`priceVOS.${scope.$index}.competitorList.${exScope.$index}.materialName`" :rules="[{required: true, trigger: 'blur'}]" label-width="0" :show-message="false">
                      <el-input v-model="exScope.row.materialName" placeholder="请输入"/>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="价格" align="center" width="100">
                  <template slot-scope="exScope">
                    <el-form-item :prop="`priceVOS.${scope.$index}.competitorList.${exScope.$index}.price`" :rules="[{required: true, trigger: 'blur'}]" label-width="0" :show-message="false">
                      <el-input v-model="exScope.row.price" class="inputCenter" placeholder="请输入"/>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="annualSalesQuantity" label="年销售量" align="center" width="100">
                  <template slot-scope="exScope">
                    <el-form-item :prop="`priceVOS.${scope.$index}.competitorList.${exScope.$index}.annualSalesQuantity`" :rules="[{required: true, trigger: 'blur'}]" label-width="0" :show-message="false">
                      <el-input v-model="exScope.row.annualSalesQuantity" class="inputCenter" placeholder="请输入"/>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="70">
                  <template v-slot="scope">
                    <el-button type="danger" @click="delateHandle(scope.row, scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column type="index" align="center" label="#" width="45"/>
        <el-table-column prop="materialNo" label="物料编号" width="100" show-overflow-tooltip/>
        <el-table-column prop="materialName" label="物料名称" width="160" show-overflow-tooltip/>
        <el-table-column prop="specification" label="规格型号" width="160" show-overflow-tooltip/>
        <el-table-column align="center" prop="standardPrice" label="标准价格" width="90"/>
        <el-table-column align="center" prop="price" label="期望销售价格(含税)" width="128">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.price"
                class="inputCenter"
                placeholder="请输入"
                @change="setGivePrice(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isGive" label="满赠" width="90">
          <template slot-scope="scope">
            <el-select v-model="scope.row.isGive" @change="setGivePrice(scope.row)">
              <el-option label="是" :value="1"/>
              <el-option label="否" :value="0"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="perReach" label="满赠条件" width="90">
          <template slot-scope="scope">
            <el-form-item
                :prop="`priceVOS.${scope.$index}.perReach`"
                :rules="[{ required: scope.row.isGive === 1, trigger: 'blur' }]"
                label-width="0"
                :show-message="false">
              <el-input
                  v-model="scope.row.perReach"
                  :disabled="scope.row.isGive === 0"
                  class="inputCenter"
                  placeholder="请输入"
                  @change="calculateGivePrice(scope.row)"/>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="perGive" label="满赠数量" width="90">
          <template slot-scope="scope">
            <el-form-item
                :prop="`priceVOS.${scope.$index}.perGive`"
                :rules="[{ required: scope.row.isGive === 1, trigger: 'blur' }]"
                label-width="0"
                :show-message="false">
              <el-input
                  v-model="scope.row.perGive"
                  :disabled="scope.row.isGive === 0"
                  class="inputCenter"
                  placeholder="请输入"
                  @change="calculateGivePrice(scope.row)"/>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="givePrice" label="满赠后价格" width="110"/>
        <el-table-column align="center" prop="quality" label="预期月用量" width="130">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quality" class="inputCenter" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="subtotalAmount" label="小计" width="130">
          <template slot-scope="scope">
            <span>{{scope.row.quality * scope.row.price}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isCus" label="定制" width="130">
          <template slot-scope="scope">
            <el-select v-model="scope.row.isCus">
              <el-option label="是" :value="1"/>
              <el-option label="否" :value="0"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="pdManagerName" label="产品经理" width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.pdManagerName" placeholder="请选择产品经理" readonly>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="$refs.employeeSelect1.open(scope.$index)"/>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button type="primary" @click="addCompetitors(scope.row, scope.$index)">竞品</el-button>
            <el-button type="danger" @click="businessApplication.priceVOS.splice(scope.$index, 1)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="editTitle" style="margin-top: 15px">商务申请附件</div>
      <div>
        <upload-file
            ref="upload"
            :auth-index="authIndex"
            style="margin-bottom: 10px; float: left"
            @upload-success="uploadSuccess"/>
        <el-table ref="payData1" :data="businessApplication.attachments" border>
          <el-table-column type="index" align="center" label="#" width="55"/>
          <el-table-column prop="fileName" align="left" label="附件描述" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.fileName"
                  class="tabInput"
                  style="width: 400px; margin: 0 auto; text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
              <el-button type="danger" @click="businessApplication.attachments.splice(scope.$index, 1)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <customer-select ref="selectCustomerName" @select="selectCustomerName"/>
    <material-select ref="selectMaterial" :is-multi-select="true" @select-change="selectMaterial"/>
    <employee-select ref="employeeSelect" @select="onSelectEmployee"/>
    <employee-select ref="salesPersonSelect" @select="salesPersonSelect"/>
    <employee-select-by-index ref="employeeSelect1" @select="onSelectEmployee1"/>
  </el-dialog>
</template>

<script>
  import CustomerSelect from "../../information/Customer/CustomerSelect";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import UploadFile from "@/components/UploadFile.vue";
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  import EmployeeSelectByIndex from "@/views/information/Employee/EmployeeSelectByIndex";

  export default {
    components: {EmployeeSelectByIndex, CustomerSelect, MaterialSelect, UploadFile, EmployeeSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        authIndex: 192,
        disabled: false,
        businessApplication: {
          businessApplicationID: "",
          businessApplicationNO: "",
          payMethod: "",
          customerID: "",
          customerName: "",
          contact: "",
          telephone: "",
          contactPositionId: "",
          timeLimit: 20,
          beginDate: "",
          endDate: "",
          note: "",
          containsFee: true,
          packDeliveryFee: "",
          priceVOS: [],
          attachments: [],
          beginEndDate: [],
          salesQuantity: "",
          yearSalesQuantity: "",
          sendPeopleId: 0,
          belongCmp: 0,
          customerAttr: 0,
          customerType: 0,
          amount: "",
          position: "",
          rebated: 0,
          rebateRange0: "",
          rebateRange1: "",
          rebateGive: "",
          totalAmount: "",
          sendPeopleName: "",
          salesPersonName:"",
          salesPersonOaNum:"",
        },
        payMethods: [],
        postList: [],
        isCopy: 0,
        expandRowKeys: [],
        ruleValidate: {
          payMethod: {required: true, message: "请选择付款方式", trigger: "change"},
          customerName: {required: true, message: "请选择客户", trigger: "change"},
          beginEndDate: {required: true, message: "请选择期限", trigger: "blur"},
          packDeliveryFee: {required: true, message: "请输入包装和运输费用", trigger: "blur"},
          position: {required: true, message: "请选择联系人职位", trigger: "blur"},
          sendPeopleName: {required: true, message: "请选择抄送商务", trigger: "blur"},
          contact: {required: true, message: "请选择联系人", trigger: "blur"},
          note: {required: true, message: "请输入备注", trigger: "blur"},
          salesPersonName: {required: true, message: "请选择业务员", trigger: "blur"},
          xiaoWei: {required: true, message: "请选择小微", trigger: "blur"},
        },
        materialFilter: {
          status: 10,//启用
          priceStatus: 30,//已通过
        },
      };
    },

    methods: {
      open(row, isCopy, mark, edit) {
        this.dialogVisible = true;
        this.isCopy = isCopy;
        this.disabled = !edit;
        this.$nextTick(() => {
          this.getPaymentTypes();
          if (row) {
            if (!mark) {
              this.getData(row.businessApplicationID);
            } else {
              let options = JSON.parse(row.sDSalesOrderVO);
              this.businessApplication.priceVOS = row.materialList;
              this.businessApplication.customerID = options.customerId;
              this.businessApplication.customerName = options.customerName;
              this.businessApplication.contact = options.contact;
              this.businessApplication.mobile = options.telephone;
              this.businessApplication.paymentTypeId = options.paymentTypeId;
              this.businessApplication.priceVOS.forEach((item) => {
                item.productID = item.materialId;
                item.floatingPrice = 0;
              });
            }
          }
        });
      },

      // 付款方式
      getPaymentTypes() {
        this.$http.get("basic", "sapSalesOrders/getPaymentType").then((res) => {
          if (res.success) {
            this.payMethods = res.data;
            this.getPosts();
          }
        });
      },

      // 获取详情
      getData(businessApplicationID) {
        this.contentLoading = true;
        this.$http
          .get("basic", `sd/ba/${businessApplicationID}/0`)
          .then((resp) => {
            if (resp.success) {
              // 使用Object.assign合并数据，保留原有的属性定义
              this.businessApplication = Object.assign({}, this.businessApplication, resp.data);
              if (this.businessApplication.beginDate && this.businessApplication.endDate) {
                this.businessApplication.beginEndDate = [this.businessApplication.beginDate, this.businessApplication.endDate];
              }
              if (this.isCopy) {
                this.businessApplication.businessApplicationID = "";
                this.businessApplication.submitTime = "";
                this.businessApplication.status = 2201;
              }
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 联系人职位
      getPosts() {
        this.$http.get("basic", "posts/list").then((res) => {
          if (res.success) {
            this.postList = res.data;
          }
        });
      },

      // 选择客户
      selectCustomerName(row) {
        this.businessApplication.customerID = row.customerID;
        this.businessApplication.customerName = row.customerName;
        this.businessApplication.contact = row.contact;
        this.businessApplication.mobile = row.telephone;
        this.businessApplication.contactPositionId = row.positionId;
        this.businessApplication.payMethod = row.zterm;
      },

      // 选择期限
      beginEndDateChange(val) {
        if (val) {
          this.businessApplication.beginDate = val[0];
          this.businessApplication.endDate = val[1];
        }
      },

      // 添加物料（多选模式，row 为数组）
      selectMaterial(row) {
        console.log(row);
        // 兼容单行传入
        const rows = Array.isArray(row) ? row : [row];
        rows.forEach((r) => {
          // 已存在物料跳过
          var result = this.businessApplication.priceVOS.some((item) => item.materialNo === r.no);
          if (result) {
            this.$confirm("物料【" + r.no + "】已存在，请勿重复添加", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          this.businessApplication.priceVOS.push({
            businessType: r.businessType,
            businessTypeName: r.businessTypeName,
            materialTypeName: r.materialTypeName,
            materialTypeId: r.materialTypeId,
            materialTypeNo: r.materialTypeNo,
            productID: r.id,
            materialNo: r.no,
            materialName: r.name,
            standardPrice: r.standardPrice,
            costPrice: r.costPrice,
            level1Price: r.level1Price,
            level2Price: r.level2Price,
            level3Price: r.level3Price,
            floatingPrice: 0,
            specification: r.zmyxh,
            unit: r.unit,
            price: "",
            pdManagerId: "",
            pdManagerName: "",
            pdManagerOaNum: "",
            competitorList: [],
            isCus: 1,
            isGive: 0,
          });
        });
      },

      // 添加竞品
      addCompetitors(row, index) {
        let obj = {
          rowIndex: row.rowIndex,
          brand: "",
          materialName: "",
          price: "",
          annualSalesQuantity: "",
          masterId: row.pkid,
        };
        console.log(row, index);
        row.competitorList.push(obj);
        this.$set(this.businessApplication.priceVOS, index, row);
        this.expandRowKeys = [row.pkid];
      },

      // 删除竞品
      delateHandle(row, index) {
        this.businessApplication.priceVOS.forEach((item, i) => {
          if (item.pkid === row.masterId) {
            item.competitorList.splice(index, 1);
            this.$set(this.businessApplication.priceVOS, i, item);
          }
        });
      },

      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.businessApplication.attachments.push(params);
        }
      },

      // 下载
      downLoad(row) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (!valid) {
            this.$message.error("请查看必填项是否填写完整");
            return;
          }
          if (valid) {
            // 校验商务申请物料
            if (!this.businessApplication.priceVOS.length) {
              this.$confirm("请添加商务申请物料", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            } else {
              let result = this.businessApplication.priceVOS.some((item) => !item.price);
              if (result) {
                this.$confirm("请输入申请价格", "错误", {
                  type: "error",
                  showCancelButton: false,
                });
                return;
              }
            }
            this.submitLoading = true;
            if (this.businessApplication.businessApplicationID) {
              this.$http
                .post("basic", "sd/ba/updatePriceApply", this.businessApplication)
                .then((resp) => {
                  if (resp.success) {
                    this.$message.success("编辑成功");
                    this.$emit("save-success");
                    this.dialogVisible = false;
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "sd/ba/insertPriceApply", this.businessApplication)
                .then((resp) => {
                  if (resp.success) {
                    this.$message.success("添加成功");
                    this.$emit("save-success");
                    this.dialogVisible = false;
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },

      setGivePrice(row) {
        if (!row.isGive) {
          this.$set(row,"givePrice", row.price);
          this.$set(row,"perReach", "");
          this.$set(row,"perGive", "");
        } else {
          this.calculateGivePrice(row);
        }
      },

      calculateGivePrice(row) {
        const price = parseFloat(row.price) || 0; // 期望销售价格（含税）
        const perReach = parseFloat(row.perReach) || 1; // 满赠条件
        const perGive = parseFloat(row.perGive) || 1; // 满赠数量
        this.$set(row,"givePrice", parseFloat(perReach * price / (perReach + perGive)).toFixed(2));
      },

      onSelectEmployee(row) {
        this.businessApplication.sendPeopleId = row.employeeID;
        this.businessApplication.sendPeopleName = row.employeeName;
      },

      salesPersonSelect(row) {
        this.businessApplication.salesPersonName = row.employeeName;
        this.businessApplication.salesPersonOaNum = row.oaNumber;
      },
      onSelectEmployee1(index, row) {
        let item = this.businessApplication.priceVOS[index];
        console.log(item, row);
        item.pdManagerId = row.employeeID;
        item.pdManagerName = row.employeeName;
        item.pdManagerOaNum = row.oaNumber;
        console.log(item, row);
      },

    },
  };
</script>

<style scoped lang="scss">
.businessApplicationEdit {
   .inputCenter .el-input__inner{
     text-align: center;
   }
  }
  ::v-deep .el-table .el-form-item--mini.el-form-item{
    margin-bottom: 0;
  }

</style>
